import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SettingsService } from 'src/app/services/settings.service';
import {MetodosServicio} from 'src/app/_helpers/interfaces/metodos-servicio';
import {AplicacionVersion} from 'src/app/_models/aplicacion-version';

@Injectable()

export class AplicacionVersionService extends MetodosServicio<AplicacionVersion> {

  constructor(
    public http: HttpClient,
    private settings: SettingsService
  ) {
    super(http, 'public/aplicacion_version', AplicacionVersion);
  }

  restartItem(): void {
    this.setItem(new AplicacionVersion());
  }

  /**
   * Método para obtener la aplicacion de una persona según su id
   * @param aplicacionVersionID identificador del tipo de  aplicacion
   */
  obtenerAplicacionVersion(filtro: any): Observable<any> {
    return this.http.get(this.settings.URL_BASE + 'public/aplicacion_version',filtro);
  }
  
  crearAplicacionVersion(data: any): Observable<any> {
    return this.http.post(this.settings.URL_BASE + 'public/aplicacion_version', data);
  }

  actualizarAplicacionVersion(data: any, id: any): Observable<any> {
    return this.http.put(this.settings.URL_BASE + 'public/aplicacion_version/' + id, data);
  }

  eliminarAplicacionVersion(id: any): Observable<any> {
    return this.http.delete(this.settings.URL_BASE + 'public/aplicacion_version/' + id);
  }
}
